import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../components/common/form/Form"
import "./loginPage.modules.css"
// @ts-ignore
import defaultLogo from "../../images/titleLogixLogo.png";
import Button from "../../components/common/form/Button";
import { Link, useNavigate } from "react-router-dom";
import { useBaseUrlQuery, useLoginUserMutation } from "./loginPageApi";
import { handleRTKQuery } from "../../helpers/utils/RtkQueryUtils";
import InputField from "../../components/common/form/InputField";
import { useDispatch, useSelector } from "react-redux";
import { clearRedirectPath, setShowSidebar } from "../../app/globalSlice/globalSlice";
import Preloader from "../../components/common/Preloader";
import ConfirmationModal from "../../components/layout/modal/ConfirmationModal";
import { showToast } from "../../helpers/utils/Utils";

const LoginPage: FC = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const redirectPath = useSelector((state: any) => state.global.redirectPath);
    const [tenantLogoUrl, setTenantLogoUrl] = useState("");
    const [tenantName, setTenantName] = useState("TGX");
    const baseUrl = `${window.location.host}`;
    const tenantData = useBaseUrlQuery(baseUrl);
    const [showChangePasswordConfirmationModal, setShowChangePasswordConfirmationModal] = useState(false);

    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
        userZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
    const [loginUser, { isLoading }] = useLoginUserMutation();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        })
    }

    const showForgotPassword = () => {
        navigate("/forgot-password")
    }

    useEffect(() => {
        if (tenantData?.data) {
            const tenantName = tenantData.data.name;
            setTenantName(tenantName);
            setTenantLogoUrl(process.env.REACT_APP_BASE_URL + `/ajax/image/bytes/${tenantData.data.logoImageId}`);
        }
    }, [tenantData]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        localStorage.clear();

        try {
            const result = await loginUser(credentials).unwrap();

            if (result?.errorCode === 200) {
                if (result.userForcePasswordResetStatus) {
                    setShowChangePasswordConfirmationModal(true);
                } else {
                    dispatch(setShowSidebar(false));
                    navigate(redirectPath);
                    dispatch(clearRedirectPath());
                }
            } else if (result?.mfaInfo) {
                const mfaResult = JSON.stringify(result);
                navigate('/verify-mfa', {
                    state: {
                        username: credentials.username,
                        password: credentials.password,
                        mfaResponse: mfaResult
                    }
                });
            } else {
                showToast(result['message'], "error");
            }
        } catch (error) {
            console.error("Login error", error);
            localStorage.clear();
        }


    };


    return (
        <>
            <section className="flex flex-col min-h-[calc(100vh-48px)]">
                {!tenantData.data ?
                    <Preloader />
                    : <>
                        <ul className={'header_links flex justify-end p-3 bg-surface-0 text-text-0 gap-2 mb-0'}>
                            <li>
                                <li>
                                    <Link onClick={(e) => {
                                        e.stopPropagation();
                                    }} to="/external/bill-releases" className={"login_page_link hover:text-highlight-0"}>Bill Releases
                                    </Link>
                                    <a href='https://www.titlelogixsolutions.com'
                                        className={"login_page_link cursor-pointer pl-4 hover:text-highlight-0"}
                                    >Go to TitleLogix</a>
                                </li>
                            </li>
                        </ul>
                        <div className="relative flex-grow flex justify-center items-center
  before:absolute before:inset-0 before:bg-custom-image before:bg-center before:bg-no-repeat before:bg-cover before:content-[''] before:filter before:blur-[2px]
  after:absolute after:inset-0 after:bg-[rgba(0,0,0,0.4)] after:content-['']">

                            <div className="w-full max-w-xl lg:max-w-lg md:max-w-md">
                                <div className="backdrop-blur-[11px] bg-surface-1  rounded-lg p-12 relative z-10">
                                    <Form onSubmit={handleSubmit} fields={
                                        <>
                                            <div className="text-center mb-4">
                                                <img loading="lazy"
                                                     src={tenantLogoUrl}
                                                     alt=""
                                                     onError={(e) => {
                                                         const target = e.target as HTMLImageElement;
                                                         target.onerror = null; // prevent infinite loop
                                                         target.src = defaultLogo;                                                     }}/>
                                            </div>
                                            <h3 className={"text-center font-bold"}>{tenantName === 'TitleLogix' ? 'TGX' : tenantName}</h3>
                                            <div className="form-group mb-4">
                                                <InputField
                                                    name="username"
                                                    type="text"
                                                    value={credentials.username}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    placeholder="Username/Email"
                                                    required={true}
                                                    hideLabel={true}
                                                />

                                            </div>

                                            <div className="form-group mb-4 relative">
                                                <InputField
                                                    type={"password"}
                                                    value={credentials.password}
                                                    name="password"
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    placeholder="Password"
                                                    required={true}
                                                    hideLabel={true}
                                                />
                                            </div>

                                            <div className="form-group mb-4 ">
                                                <Button
                                                    className="text-text-0  rounded-full px-8 py-2 bg-surface-0 hover:bg-highlight-0"
                                                    btnText={"Login"} isLoading={isLoading} type={"submit"}></Button>
                                            </div>

                                            <div className="forgot-password-txt mb-3 pass_recall">
                                                <a className={"m-2 cursor-pointer text-text-0"} onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate("/forgot-password")
                                                }}
                                                >Forgot Password?</a>
                                            </div>
                                        </>
                                    } />
                                </div>
                            </div>

                        </div>
                    </>}
            </section>

            {showChangePasswordConfirmationModal && <ConfirmationModal title={"Alert"}
                bodyMessage={"Your password needs to be reset for security reasons. Please create a new password to continue."}
                onSubmit={showForgotPassword}
                show={showChangePasswordConfirmationModal}
                setShow={setShowChangePasswordConfirmationModal}
            />
            }
        </>
    );
}
export default LoginPage